import User1 from '@assets/images/sales/user1.webp'
import User2 from '@assets/images/sales/user2.webp'
import User3 from '@assets/images/sales/user3.webp'
import { NEW_PROGRAM_PROFILE } from './enum'

export const SCHOOL_EDUCATION_DATA = {
  SCHOOL_NAME: 'School Name',
  CLASS: 'Class',
  STREAM: 'Stream',
  SCHOOL_ID_CARD: 'School ID Card',
  REFERRAL_CODE: 'Referral Code',
}

export const AFFILIATE_DATA = {
  SHOP_NAME: 'Shop Name',
  SHOP_IMAGE: 'Shop Photo',
  REFERRAL_CODE: 'Referral Code',
  PROFESSIONAL_CAT: 'Professional Category',
  JOB_ROLE: 'Job Role',
  PROOF_OF_ROLE: 'Proof of Role',
  ME_MOBILE_NO: 'ME/ML Mobile Number'
}

export const COLLEGE_FORM_PLACEHOLDER_TYPE = {
  COLLEGE_ID_CARD: 'College ID Card',
  COURSE_NAME: 'Course Name',
  COLLEGE_NAME: 'College Name',
  COLLEGE_EMAIL_ID: 'College Email Id',
  GRADUATION_YEAR: 'Graduation Year',
  INSERT_OTHER_COLLEGE: 'Write College Name',
  INSERT_OTHER_COURSE: 'Write Course Name',
  REFERRAL_CODE: 'Referral Code',
  ACADEMIC_YEAR: 'Academic Year',
  SEMESTER: 'Semester'
}

export const ProfileType = {
  influencerCategory: 'Influencer Category',
  influencerRole: 'Influencer Role',
  proofOfRole: 'Proof Of Role',
}
export const influencerData = {
  YOUTUBE_DESCRIPTION: 'Example: https://www.youtube.com/@PhysicsWallah ',
  FB_DESCRIPTION: 'Example: https://www.faceboook/@PhysicsWallah ',
  INSTA_DESCRIPTION: 'Example: https://www.instagram.com/@PhysicsWallah ',
}

export const affiliateType = [
  { label: 'Educators', value: 'Educators' },
  { label: 'Content Creator', value: 'Content Creator' },
  { label: 'Bloggers', value: 'Bloggers' },
  { label: 'Others', value: 'Others' },
]

export const saathiTypeList = [
  { label: 'Tuition Tutor', value: 'Tuition_Tutor' },
  { label: 'School Teacher', value: 'School_Teacher' },
  { label: 'Admission Consultant', value: 'Admission_Consultant' },
  { label: 'School Association', value: 'School_Association' },
]

export const COURSE_NAME_LIST = [
  { name: 'MBBS' },
  { name: 'BTech' },
  { name: 'BCom' },
  { name: 'BArch' },
]
export const countryCodes = []

export const defaultUserPaymentDetails = {
  bankAccountNumber: '',
  bankHolderName: '',
  bankName: '',
  ifscCode: '',
  bankBranch: '',
  panCardNumber: '',
  passbookFirstPage: '',
  gstCertificate: '',
  panCard: '',
  passportPhoto: '',
  msmeCertificate: '',
  msmeRegNo: '',
  selfDeclaration: '',
  addressLine: '',
  city: '',
  state: '',
  pincode: '',
  houseAddress: '',
}

export const minUserNameLength = 4

export const indiaDialCode = '+91'

export const indianCountryCode = 'IN'

export const couponStatusTitle = {
  PENDING: 'PENDING',
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
}
export const applicationStatusTitle = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
  REVOKED: 'REVOKED',
}

export const defaultcollegeDetails = {
  profileStage: '',
  programType: '',
  campusProgramType: '',
  courseName: '',
  collegeName: '',
  collegeEmailId: '',
  graduationYear: '',
  collegeIdCard: '',
  insertOtherCollege: '',
  insertOtherCourse: '',
  collegeType: '',
  courseType: '',
  semester: ''
}

export const defaultAffiliateDetails = {
  programType: '',
  shopName: '',
  shopImage: '',
  referralCode: '',
}
export const defaultAffiliateFreelancerDetails = {
  influencerCategory: '',
  influencerRole: '',
  proofOfRole: '',
  programType: '',
  referralCode: '',
}

export const defaultSaathiInput = {
  empCategory: '',
  organization: '',
  vpCenter: '',
  proofOfEmpolyement: '',
  profileStage: '',
  programType: '',
  referralCode: '',
  parentPhone: ''
}

export const defaultDetailsSchool = {
  campusProgramType: '',
  schoolName: '',
  class: '',
  stream: '',
  schoolIdCard: '',
  referralCode: '',
}

export const defaultPersonalDetails = {
  isDropdownOpen: false,
  isDropdownCity: false,
}

export const ProfileStage = {
  PAYMENT: 'PAYMENT_DETAILS',
  SELECTION: 'PROGRAM_SELECTION',
  PERSONAL: ' PERSONAL_DETAILS',
}

export const TILE_TYPE = {
  Revenue: 'Revenue',
  Sales: 'No. of Sales',
  Payouts: 'Payouts',
  Accepted: 'Totel Leads(Accepted)',
  Conversion: 'Successful Conversions',
  earning: 'Expected Earning*',
  SignUp: 'No. of Sign-up',
}

export const TILE_NO = {
  TILE_NO_1: 'Level1',
  TILE_NO_2: 'Level2',
  TILE_NO_3: 'Level3',
}

export const DATA_CAME_FORM = {
  status: 'status',
  payment: 'Add Payment Details',
}
export const noDataFields = [
  NEW_PROGRAM_PROFILE.PROFESSIONAL,
  NEW_PROGRAM_PROFILE.SCHOOL,
  NEW_PROGRAM_PROFILE.ENGINEERING,
  NEW_PROGRAM_PROFILE.OTHER_FIELDS,
  NEW_PROGRAM_PROFILE.POST_GRADUATE,
  NEW_PROGRAM_PROFILE.SHOP_BUSINESS,
  NEW_PROGRAM_PROFILE.DIFF_BUSINESS,
  NEW_PROGRAM_PROFILE.ADVAN_MEDICAL,
  NEW_PROGRAM_PROFILE.OTHER_COURSES,
]

export const SAATHI_DATA = {
  PROFESSIONAL_CAT: 'Professional Category',
  ORG_NAME: 'Proof of Employment',
  PROOF_OF_ROLE: 'Proof of Role',
  VP_CENTER: 'Vidyapeeth Centre',
  REFERRAL_CODE: 'Referral Code',
  ML_NUMBER: 'ML/ME Number'
}

export enum POP_UP_CTA_NAME {
  EXPLORE = "explore",
  BUY_NOW = "buy_now",
  locked_offering = "locked_offering",
  ALL_CLASSES_UPGRADE_BANNER = "all_classes_upgrade_banner",
}
export const PLAYER_ACTIONS = {
  BACK: false,
  REPORT: false,
  DOCUMENT: false,
  DOUBTS: false,
  TIMELINE: false,
  CHAT: false,
};
export const VIDEO_TYPE = {
  penpencilvdo: "PENPENCILVDO",
  youtube: "YOUTUBE",
  awsVideo: "AWS_LIVE",
  mp4: "MP4",
};
export enum BATCH_PLUS_TABLE_CTA {
  UPGRADE_NOW = "Upgrade Now",
  BUY_NOW = "Buy Now",
  ENROLL_NOW = "Enroll Now",
}

export const AUTH_SDK_ID = 'pw_auth-flow';
export const GuideModalData = [
  { image: User1, imgMargin: '32', heading: 'Help a student buy their preferred PW batch', subheading: 'Select the student’s exam and class and explore all available batches at PW.', btn1: '', btn2: 'Next' },
  { image: User2, imgMargin: '43', heading: 'Enter student details for batch access & checkout', subheading: 'Provide student’s full name and mobile number to register/login to their PW account and buy the batch at a discount price', btn1: 'Previous', btn2: 'Next' },
  { image: User3, imgMargin: '38', heading: 'Student gets the batch, you earn more!', subheading: 'Student will get batch access on their mobile number while you will earn higher commission', btn1: 'Previous', btn2: 'Finish' },
]

export const capitalizeFirstLetter = (val: string) => {
  if (!val || val.trim().length === 0) return val

  return val
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('_')
}

export enum CheckoutExperimentVariant {
  CONTROL = 'CONTROL',
  TARGET_ONE = 'TARGET_ONE',
  TARGET_TWO = 'TARGET_TWO',
  TARGET_THREE = 'TARGET_THREE',
}

export const CHECKOUT_EXPERIMENT_NAME = 'new-checkout-ab-web';
export const PW_CAPTCHA_EXPERIMENT_NAME = 'captcha-control-ambassador';
/** Ambassador-specific captcha flag (Unleash) — parallel to gcms `captcha-control-pw` */
/** Unleash feature flag / experiment names (mirrors cjr-web-revamp / gcms pattern) */
export const UNLEASH_EXPERIMENTS = {
  NEW_CHECKOUT_AB_WEB: CHECKOUT_EXPERIMENT_NAME,
  PW_CAPTCHA: PW_CAPTCHA_EXPERIMENT_NAME,
}

const CHECKOUT_VARIANT_VALUES = new Set<string>(
  Object.values(CheckoutExperimentVariant),
);

export const isCheckoutVariant = (
  value: unknown,
): value is CheckoutExperimentVariant =>
  typeof value === 'string' && CHECKOUT_VARIANT_VALUES.has(value);

export const CERTIFICATE_FILE_NAME = 'Ambassador_Certificate'
export const certificateIcon = 'https://static.pw.live/5eb393ee95fab7468a79d189/6467fa02-56c9-4dbe-a02a-5bba5080b84c.webp'
export const CERTIFICATE_MAX_WIDTH = 1036
export const CERTIFICATE_ASPECT_RATIO = 1036 / 800
export const CONGRATS_DURATION = 2400
export const TAGLINE_DURATION = 2400
export const MAX_POLL_ATTEMPTS = 20
